import { Link } from "react-router-dom";

export default function Header() {
  return (
    <header className="site-header">
      <nav className="page-shell nav-inner" aria-label="Main navigation">
        <Link className="wordmark" to="/" aria-label="Nori home">
          <span className="wordmark-mark" aria-hidden="true">n</span>
          <span>nori</span>
        </Link>
        <div className="nav-links">
          <a href="/#workflow">Platform</a>
          <a href="/#pricing">Pricing</a>
          <Link to="/case-studies">Case studies</Link>
          <Link to="/docs">Docs</Link>
          <div className="nav-item has-menu">
            <Link to="/about">About</Link>
            <div className="nav-menu">
              <Link to="/team">Team</Link>
              <Link to="/contact">Contact</Link>
            </div>
          </div>
        </div>
        <Link className="button button-nav" to="/contact">Talk to Nori <span aria-hidden="true">↗</span></Link>
      </nav>
    </header>
  );
}
